import { motion } from "framer-motion";
import { Plug, Cpu, ShieldOff } from "lucide-react";

const STEPS = [
  {
    n: "01",
    icon: Plug,
    title: "Connect your ad accounts",
    desc: "One-click OAuth with Google, Meta & Bing. No pixels, no code changes, no tracking scripts to install.",
  },
  {
    n: "02",
    icon: Cpu,
    title: "AI analyzes every click",
    desc: "Our models score each visitor across 100+ signals — device, network, behavior, velocity — in real time.",
  },
  {
    n: "03",
    icon: ShieldOff,
    title: "Auto-block malicious IPs",
    desc: "Fraudulent sources are pushed straight to your exclusion lists instantly. Your budget goes to real humans.",
  },
];

export const HowItWorks = () => {
  return (
    <section
      id="how"
      className="relative py-24 lg:py-32 border-t border-white/5 overflow-hidden"
    >
      <div
        className="absolute inset-0 opacity-[0.15] bg-cover bg-center pointer-events-none"
        style={{
          backgroundImage:
            "url('https://images.unsplash.com/photo-1680992046626-418f7e910589?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600')",
        }}
      />
      <div className="absolute inset-0 bg-gradient-to-b from-[#040914] via-[#040914]/70 to-[#040914] pointer-events-none" />

      <div className="max-w-7xl mx-auto px-6 lg:px-8 relative z-10">
        <div className="max-w-2xl mb-16">
          <span className="font-mono text-xs tracking-widest uppercase text-cyan-neon">[03] How it works</span>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl tracking-tight text-white mt-4 leading-tight">
            Live protection in three moves.
          </h2>
        </div>

        <div className="grid md:grid-cols-3 gap-5">
          {STEPS.map((s, i) => {
            const Icon = s.icon;
            return (
              <motion.div
                key={s.n}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: i * 0.12 }}
                className="relative rounded-2xl bg-[#0B101A]/80 backdrop-blur-md border border-white/8 p-8 hover:border-cyan-neon/30 transition-colors"
              >
                <div className="flex items-center justify-between mb-8">
                  <span className="font-display text-5xl text-white/10">{s.n}</span>
                  <Icon className="w-7 h-7 text-cyan-neon" strokeWidth={1.75} />
                </div>
                <h3 className="font-display text-xl text-white mb-3">{s.title}</h3>
                <p className="text-sm text-slate-400 leading-relaxed font-light">{s.desc}</p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
